module.exports = __webpack_public_path__ + "static/media/no_img_available.09893593.jpg";